import { render, staticRenderFns } from "./lender-transactions-container.vue?vue&type=template&id=52d083b6"
import script from "./lender-transactions-container.vue?vue&type=script&lang=ts"
export * from "./lender-transactions-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports